import { Layout } from '@/features/layout/types'
import { useAppSelector } from '@/hooks/redux'
import { ordersSelectors } from '@/redux/reducers/orders/selectors'
import { useIsFocused } from '@react-navigation/native'
import { useEffect, useState } from 'react'
import { AppState } from 'react-native'

export const useMapPauseState = (hidden: boolean, layout: Layout) => {
    const focused = useIsFocused()
    const selectedOrder = useAppSelector(ordersSelectors.selectedOrderUuid)
    const [foreground, setForeground] = useState(AppState.currentState === 'active')

    useEffect(function trackForegroundState() {
        const subscription = AppState.addEventListener('change', (state) =>
            setForeground(state === 'active')
        )
        return () => subscription.remove()
    }, [])

    const showingOrderDetail = layout === 'extended' && Boolean(selectedOrder)

    return hidden || !focused || !foreground || showingOrderDetail
}
